export enum BlockAQueries {
  ForecastChart = 'forecastChart',
}
